// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Content{width:100%;flex-grow:1}`, "",{"version":3,"sources":["webpack://./source/layout/Content.scss"],"names":[],"mappings":"AAEA,SACC,UAAA,CACA,WAAA","sourcesContent":["@import \"/source/global.scss\";\n\n.Content {\n\twidth: 100%;\n\tflex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
